import { SharedModule } from './../../shared/shared.module';
import { SalesCapacityRoutingModule } from './sales-capacity-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesCapacityComponent } from './sales-capacity.component';
import { SalesShopMaxComponent } from './sales-shop-max/sales-shop-max.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
    declarations: [SalesCapacityComponent, SalesShopMaxComponent],
    imports: [
        SalesCapacityRoutingModule,
        CommonModule,
        SharedModule,
        TranslateModule
    ],
    exports: [TranslateModule]
})
export class SalesCapacityModule { }
